import axiosInstance from '../variables/api/axiosInstance';

const unwrap = (res) => res?.data?.data;

const bilateralesService = {
  /* ─── Rencontres bilatérales ─── */
  list: (params = {}) => axiosInstance.get('/v1/rencontres-bilaterales', { params }).then(unwrap),
  get: (id) => axiosInstance.get(`/v1/rencontres-bilaterales/${id}`).then(unwrap),
  create: (payload) => axiosInstance.post('/v1/rencontres-bilaterales', payload).then(unwrap),
  update: (id, payload) => axiosInstance.put(`/v1/rencontres-bilaterales/${id}`, payload).then(unwrap),
  changerStatut: (id, statut) =>
    axiosInstance.patch(`/v1/rencontres-bilaterales/${id}/statut`, null, { params: { statut } }).then(unwrap),
  supprimer: (id) =>
    axiosInstance.delete(`/v1/rencontres-bilaterales/${id}`).then(unwrap),

  /* ─── Sessions ─── */
  listSessions: (rbId) => axiosInstance.get(`/v1/rencontres-bilaterales/${rbId}/sessions`).then(unwrap),
  addSession: (rbId, payload) =>
    axiosInstance.post(`/v1/rencontres-bilaterales/${rbId}/sessions`, payload).then(unwrap),
  updateSession: (sessionId, payload) =>
    axiosInstance.patch(`/v1/sessions-compagnie/${sessionId}`, payload).then(unwrap),
  listDossiersOfSession: (sessionId) =>
    axiosInstance.get(`/v1/sessions-compagnie/${sessionId}/dossiers`).then(unwrap),
  addDossierToSession: (sessionId, payload) =>
    axiosInstance.post(`/v1/sessions-compagnie/${sessionId}/dossiers`, payload).then(unwrap),
  sinistresEligibles: (compagnieTrackingId, bureauHomologueTrackingId) =>
    axiosInstance.get('/v1/sessions-compagnie/eligibles', {
      params: { compagnieTrackingId, bureauHomologueTrackingId },
    }).then(unwrap),
  importerNumeros: (sessionId, numeros) =>
    axiosInstance.post(`/v1/sessions-compagnie/${sessionId}/import-dossiers`, { numeros }).then(unwrap),

  /* ─── Dossiers bilatéraux ─── */
  getDossier: (id) => axiosInstance.get(`/v1/dossiers-bilateraux/${id}`).then(unwrap),
  enregistrerDecision: (id, payload) =>
    axiosInstance.patch(`/v1/dossiers-bilateraux/${id}/decision`, payload).then(unwrap),
  deleteDossier: (id) => axiosInstance.delete(`/v1/dossiers-bilateraux/${id}`).then(unwrap),
  relanceManuelle: (id) =>
    axiosInstance.post(`/v1/dossiers-bilateraux/${id}/relance-manuelle`).then(unwrap),

  /* ─── Relances bilatérales ─── */
  listRelances: (statut) =>
    axiosInstance.get('/v1/relances-bilaterales', { params: { statut } }).then(unwrap),
  resoudreRelance: (id, motif) =>
    axiosInstance.patch(`/v1/relances-bilaterales/${id}/resoudre`, null, { params: { motif } }).then(unwrap),

  /* ─── Exports ─── */
  exportExcelUrl: (id) => `/v1/rencontres-bilaterales/${id}/export/excel`,
  exportWordUrl: (id) => `/v1/rencontres-bilaterales/${id}/export/word`,
  exportSessionWordUrl: (sessionId) => `/v1/sessions-compagnie/${sessionId}/export/word`,
  lettrePreChecklistUrl: (sessionId) => `/v1/sessions-compagnie/${sessionId}/lettre-pre-checklist`,
  downloadExport: async (url, filename) => {
    const res = await axiosInstance.get(url, { responseType: 'blob' });
    const blob = new Blob([res.data]);
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    a.click();
    URL.revokeObjectURL(a.href);
  },

  /* ─── Extensions sinistre ─── */
  getDossiersBilaterauxDuSinistre: (sinistreId) =>
    axiosInstance.get(`/v1/sinistres/${sinistreId}/dossiers-bilateraux`).then(unwrap),
  getInsuffisancesDuSinistre: (sinistreId) =>
    axiosInstance.get(`/v1/sinistres/${sinistreId}/insuffisances`).then(unwrap),

  /* ─── Marqueur visuel + recherche directe + pre-checklist ─── */
  toggleMarqueur: (dbId, payload) =>
    axiosInstance.patch(`/v1/dossiers-bilateraux/${dbId}/marqueur`, payload).then(unwrap),
  chercherSinistreParNumero: (numero) =>
    axiosInstance.get('/v1/dossiers-bilateraux/recherche-sinistre', { params: { numero } }).then(unwrap),
  preChecklist: (rbId) =>
    axiosInstance.get(`/v1/rencontres-bilaterales/${rbId}/pre-checklist`).then(unwrap),

  /* ─── Démo (SE uniquement) ─── */
  seedDemo: () =>
    axiosInstance.post('/v1/bilaterales/seed-demo').then(unwrap),
};

export default bilateralesService;
